import { Col } from './../../components/shared/home-searcher/data-table/Col';
import { SearchCountry } from "src/app/components/shared/home-searcher/data-table/SearchCountry";

export interface Icountry {
  name?: string;
  code?: string;
  service?: string;
  url_find?: SearchCountry[];
  mail_contacto?: string;
  rds_country?: string;
}

export class Country {
  private name?: string;
  private code?: string;
  private service?: string;
  private tableConfi?: Col[];
  private mail_contacto?: string;
  private rds_country?: string;

  url_find?: SearchCountry[];

  constructor() {
    // this is intentional
  }

  getName(): string {
    return this.name;
  }

  getCode(): string {
    return this.code;
  }

  getProfileList(): string[] {
    return this.url_find.map(typeProfile => { return typeProfile.type });
  }

  getMailContacto(): string {
    return this.mail_contacto;
  }

  // Nombre normalizado del país (sin tildes ni espacios) usado para armar
  // dominios RDS_<pais>. Si falta el dato (ej. countries cargados desde
  // fuentes viejas sin este campo), se deriva de forma segura desde name.
  getRdsCountry(): string {
    if (this.rds_country) {
      return this.rds_country;
    }
    return this.normalizeRdsCountry(this.name);
  }

  private normalizeRdsCountry(value: string): string {
    if (!value) {
      return '';
    }
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // quita tildes/diacríticos
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  getService(): string {
    return this.service;
  }

  getUrlFindFull(): SearchCountry[] {
    return this.url_find;
  }


  getUrlFind(typePerson: string): string {
    const serviceTklKlHash = (this.getService() === 'kl') ? 'gkl' : this.getService();
    try {
      return this.url_find.find(({ type }) => type === typePerson)['url_page'][serviceTklKlHash];
    } catch (error) {
      return "";
    }
  }

  getTableConfiguration() {
    return this.tableConfi;
  }

  setName(name: string) {
    this.name = name;
  }

  setCode(code: string) {
    this.code = code;
  }

  setMailContacto(mail_contacto: string) {
    this.mail_contacto = mail_contacto;
  }

  setRdsCountry(rds_country: string) {
    this.rds_country = rds_country;
  }


  setService(service: string) {
    this.service = service;
  }

  setItemTabla(item: { title: string, attributeName: string }) {
    this.tableConfi.unshift(item);
  }

  setTableConfig(configTable: Col[]) {
    this.tableConfi = configTable;
  }

}
